export const formatSkillPathForDisplay = (
  path: string,
  options?: {
    separator?: string;
  },
): string => {
  const separator = options?.separator ?? " › ";
  return path.split("/").filter(Boolean).join(separator);
};
